import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import { Close, Public } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles((theme)=>({
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        display : 'grid',
        alignItems : 'center',
        padding: '0px'
    },
    TitleMobile : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        display : 'grid',
    },
    Content : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    ScrollableContent : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        overflowY: 'auto',
        display : 'grid',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent : 'center',
    },
    ScrollableContentMobile : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        overflowY: 'auto',
        maxHeight: '30vh',
        display : 'grid',
        justifyContent: 'center',
        alignContent : 'center',
    },
    root : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '16px !important',
        fontWeight : '400 !important',
    },
    rootMob : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '10px !important',
        fontWeight : '400 !important',
    },
    PaperMob : {
        width : '100%',
        backgroundColor : 'black',
        color : 'white',
        height : '40%',
        display : 'grid',
    },
    Paper : {
        width : '30vw',
        backgroundColor : 'black',
        color : 'white',
        height : '40vh',
        display : 'grid',
    },
    Close: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        '&:hover' : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        }
    },
    CloseMob: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1rem !important',
            color : '#fe752f',
        },
        '&:hover' : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        }
    },
    listItem : {
        marginBottom : '1vh',
        borderRadius : '5px',
        backgroundColor : 'black',
        color : 'white',
    },
    button : {
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        },
    },
    buttonMob : {
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        },
    },
    daction : {
        justifyContent : 'center !important',
    }
}))

const QrPrompt = function QrPrompt({ qr,open, handleClose, view }){

    const classes = useStyles();

    return(
        <Dialog fullWidth={ view === 'mobile' ? true : false } classes={{ paper : view === 'mobile' ? classes.PaperMob : classes.Paper }} maxWidth='xl' open={open} >
            <DialogTitle disableTypography={true} classes={{ root : view === 'mobile' ? classes.TitleMobile : classes.Title }} >
                <IconButton classes={{ root : view === 'mobile' ? classes.CloseMob : classes.Close }} onClick={handleClose} >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent classes={{ root : view === 'mobile' ? classes.ScrollableContentMobile : classes.ScrollableContent }} >
                <Divider />
                <img src={qr || ''} alt="QR Code - Share portal code" style={ view === 'mobile' ? { width : '50vw' } : {  }} />
            </DialogContent>
            <DialogActions classes={{ root : classes.daction }} >
                Scan QR code to join portal
            </DialogActions>
        </Dialog>
    )

}

export default QrPrompt;